import { WebPortalDashboardInitialData } from "app/types/dataInterfaces";
import { processDate } from "app/util/dateUtils";
import L from "leaflet";
import iconMarker from 'leaflet/dist/images/marker-icon.png';

export const createMap = () => {
    const map = L.map('map', { worldCopyJump: true }).setView([30.85318, 40.34531], 2);

    map.options.minZoom = 2;
    map.options.maxZoom = 10;
    map.scrollWheelZoom.disable();

    L.tileLayer('https://server.arcgisonline.com/ArcGIS/rest/services/Canvas/World_Light_Gray_Base/MapServer/tile/{z}/{y}/{x}', {
        attribution: 'Tiles &copy; Esri &mdash; Sources: GEBCO, NOAA, CHS, OSU, UNH, CSUMB, National Geographic, DeLorme, NAVTEQ, and Esri', noWrap: false
    }).addTo(map);

    const defaultIcon = L.icon({
        iconUrl: iconMarker,
        iconSize: [15, 25],
        iconAnchor: [7, 25]
    });

    L.Marker.prototype.options.icon = defaultIcon;

    return map;
}

export const createCurrentPositionMarker = (booking: WebPortalDashboardInitialData) => {
    if (booking.isFavourite === true) {
        return createCurrentPositionIsFavouriteMarker();
    }

    return createCurrentPositionRedMarker();
}

export const createCurrentPositionRedMarker = () => {
    var geojsonMarkerOptions = {
        radius: 5,
        fillColor: "#FF0000",
        color: "#000",
        weight: 0,
        opacity: 1,
        fillOpacity: 1
    };

    return geojsonMarkerOptions;
}

export const createCurrentPositionIsFavouriteMarker = () => {
    var geojsonMarkerOptions = {
        radius: 5,
        fillColor: "#FFB81C",
        color: "#000",
        weight: 0,
        opacity: 1,
        fillOpacity: 1
    };

    return geojsonMarkerOptions;
}

export const createCurrentPositionPopUp = (booking: WebPortalDashboardInitialData) => {
    let popup = "";

    if (booking.shipmentRef) {
        popup += `<strong>Shipment Ref:</strong>

                <a href=/LeoSeaPortal/bookingdetails?shipmentId=${booking.shipmentID} style="color: black">
                <u>${booking.shipmentRef}</u></a> </br>`
    }

    if (booking.purchaseOrderReferenceNo) {
        popup += `PO Number: ${booking.purchaseOrderReferenceNo } </br>`
    }

    if (booking.estimatedArrivalDate) {
        popup += `Shipment ETA: ${processDate(booking.estimatedArrivalDate)}`;
    }

    return popup;
}

export const createCurrentPositionMultiPopUp = (bookings: WebPortalDashboardInitialData[]) => {
    let popup = "";

    bookings.forEach((booking, index, arr) => {
        popup += createCurrentPositionPopUp(booking);
        if (index !== arr.length - 1) {
            popup += '<hr />';
        }
    })

    return popup;
}

export function groupByConsolId(initialData: WebPortalDashboardInitialData[] | undefined) {
    return initialData?.reduce((acc, obj) => {
        if (!acc[obj.consolId]) {
            acc[obj.consolId] = [];
        }

        acc[obj.consolId].push(obj);
        return acc;
    }, {});
}